import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconListAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"list-add, list-plus, new-list"} maskId="square-filled-radius-0-stroke-1-IconListAdd"><path d="M18 14H22V15H18V19H17V15H13V14H17V10H18V14Z" fill="currentColor"/><path d="M10 18H3V17H10V18Z" fill="currentColor"/><path d="M10 12H3V11H10V12Z" fill="currentColor"/><path d="M21 6H3V5H21V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconListAdd;
